<template>
    <div class="w-full p-3">
        
        <Carousel v-if="layout.images?.media?.length" 
            :value="paddedImages" 
            :numVisible="4" 
            :numScroll="1" 
            :responsiveOptions="responsiveOptions" 
            :circular="true"
            :autoplayInterval="0"
            :class="['image-carousel', { 'hide-arrows': (layout.images?.media?.length || 0) <= 4 }]">
            <template #item="slotProps">
                <div class="carousel-item h-full">
                    <div v-if="!slotProps.data.isEmpty" 
                        class="border border-gray-200 rounded-lg overflow-hidden cursor-pointer h-full flex flex-col"
                        @click="$emit('editImage', { imageId: slotProps.data.id, filters: layout.filters })">
                        <div class="relative">
                            <img :src="slotProps.data.img_base64_val || slotProps.data.imageData.previewImg" 
                                :alt="slotProps.data.fileName" 
                                class="w-full h-48 object-cover" />
                        </div>
                        <div class="px-3 py-2 text-xs text-gray-600 bg-white flex-grow">
                            {{ slotProps.data.createdDate }}
                        </div>
                    </div>
                    <div v-else class="invisible h-full w-full"></div>
                </div>
            </template>
        </Carousel>

        <div v-else class="text-center py-6">
            <div class="text-sm mb-2 text-gray-600">{{$t('No contains images')}}</div>
            <button type="button" class="btn w-32 bg-gray-600 text-white zoom-in font-normal" @click="$emit('updateTab', 'upload')">{{ $t('Upload') }}</button>
        </div>

    </div>
</template>

<script setup>
import { onMounted, ref, computed }   from "vue";
import Carousel             from 'primevue/carousel';
import * as rosepetalModel  from "rosepetal-model";

const $dataset = rosepetalModel.default.dataset;

const props = defineProps({
    dataset: {
        type: Object,
        required: true
    }
});

const layout = ref({
    images: {},
    action: {},
    filters: {
        limit:          0,
        objtagsType:    'all',
        objByTag:       'all',
        order:          'date',
        direction:      'desc'
    }
});

const responsiveOptions = ref([
    {
        breakpoint: '1400px',
        numVisible: 4,
        numScroll: 1
    },
    {
        breakpoint: '1200px',
        numVisible: 3,
        numScroll: 1
    },
    {
        breakpoint: '992px',
        numVisible: 2,
        numScroll: 1
    },
    {
        breakpoint: '768px',
        numVisible: 1,
        numScroll: 1
    }
]);

const paddedImages = computed(() => {
    const images = layout.value.images?.media || [];
    const result = [...images];
    
    while (result.length < 4 && result.length > 0) {
        result.push({ isEmpty: true, id: `filler-${result.length}` });
    }
    
    return result;
});

const loadImages = async () => {
    if (props.dataset) {
        const opt = {
            objtagsType:    layout.value.filters.objtagsType,
            objByTag:       layout.value.filters.objByTag,
            limit:          layout.value.filters.limit,
            order:          layout.value.filters.order
        };
        layout.value.images = await $dataset.getImages(props.dataset, opt);
    }
}

onMounted(() => {
    loadImages();
});

defineExpose({
    loadImages
});
</script>

<style scoped>
.image-carousel {
    position: relative;
    overflow: hidden;
}

.image-carousel :deep(.p-carousel-container) {
    padding: 0;
}

.image-carousel :deep(.p-carousel-items-content) {
    justify-content: flex-start !important;
}





.carousel-item {
    max-width: 280px;
    margin: 0 4px;
}

@media (min-width: 1600px) {
    .carousel-item {
        max-width: 350px;
        margin: 0 1px;
    }
}

@media (min-width: 1200px) and (max-width: 1599px) {
    .carousel-item {
        margin: 0 2px;
    }
}

@media (min-width: 992px) and (max-width: 1199px) {
    .carousel-item {
        margin: 0 3px;
    }
}

@media (max-width: 768px) {
    .carousel-item {
        margin: 0 2px;
    }
}

.image-carousel :deep(.p-carousel-prev),
.image-carousel :deep(.p-carousel-next) {
    width: 2.25rem;
    height: 2.25rem;
    color: #374151;
    background: rgba(255, 255, 255, 0.7);
    border: none;
    border-radius: 50%;
    transition: all 0.2s ease-in-out;
    z-index: 10 !important;
    position: absolute !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
}

.image-carousel :deep(.p-carousel-prev:hover),
.image-carousel :deep(.p-carousel-next:hover) {
    background: white;
    transform: translateY(-50%) scale(1.1) !important;
}

.image-carousel :deep(.p-carousel-prev) {
    left: 0.75rem !important;
}

.image-carousel :deep(.p-carousel-next) {
    right: 0.75rem !important;
}

.image-carousel :deep(.p-carousel-indicators) {
    display: none;
}

.image-carousel.hide-arrows :deep(.p-carousel-prev),
.image-carousel.hide-arrows :deep(.p-carousel-next) {
    display: none !important;
}
</style> 